/**
 * Néphrologie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: NEPH
 * Catalogue acts (NGAP Maroc): 30
 */
import { defineSpecialty } from "../types";

export const nephrologie = defineSpecialty(
{
  "id": "nephrologie",
  "label": "Néphrologie",
  "short": "Néphro.",
  "scope": "Reins, dialyse, transplantation",
  "aliases": [
    "NEPH"
  ],
  "doctorSpecs": [
    "Néphrologie"
  ],
  "featureFlag": "ux.v2.nephrologie",
  "theme": {
    "primary": "oklch(0.67 0.12 275)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "dialysis",
      "label": "Dialyse",
      "icon": "Droplet",
      "route": "/clinical/dialysis",
      "order": 2,
      "requires": [
        "dialysis"
      ]
    },
    {
      "id": "lab",
      "label": "Laboratoire",
      "icon": "FlaskConical",
      "route": "/clinical/lab",
      "order": 3,
      "requires": [
        "lims"
      ]
    },
    {
      "id": "transplant",
      "label": "Transplantation",
      "icon": "ShieldCheck",
      "route": "/clinical/transplant",
      "order": 4,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "renal",
      "label": "Rénal",
      "icon": "Droplet",
      "component": "RenalPanel",
      "order": 1,
      "requires": []
    },
    {
      "id": "labs",
      "label": "Bilan",
      "icon": "FlaskConical",
      "component": "LabResultsGrid",
      "order": 2,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Néphrologie",
    "subSpecialties": [
      "Consultation",
      "Dialyse",
      "Greffe",
      "Exploration"
    ],
    "catalogueActs": 30
  },
  "terminology": {
    "icd10": [
      "N00",
      "N18",
      "N19",
      "N25",
      "I10"
    ],
    "loinc": [
      "33914-3",
      "2951-2"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "dialysis-monitor",
    "ultrasound-renal",
    "hemodialysis-machine"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default nephrologie;
